import { CV } from "@/data/cv";

export default function About() {
  return (
    <section id="ueber-mich" data-testid="about-section" className="py-24 md:py-32 border-b-2 border-black">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {/* Portrait — kleiner & links-bündig */}
          <div className="lg:col-span-3">
            <div className="relative w-40 sm:w-48 md:w-56 lg:w-full lg:max-w-[240px]">
              <div className="absolute -inset-1 md:-inset-1.5 bg-[#FF3B00] -z-0" aria-hidden="true" />
              <div className="relative border-2 border-black bg-black overflow-hidden">
                <img
                  data-testid="about-portrait"
                  src={CV.portrait}
                  alt={CV.name}
                  className="w-full h-auto object-cover aspect-[4/5]"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-9">
            <p className="font-mono-acc text-xs text-[#525252] mb-3">// 01 — Profil</p>
            <h2 className="font-display uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
              Über<br />
              <span className="text-[#FF3B00]">mich.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg leading-relaxed max-w-2xl">
              {CV.about}
            </p>

            <div className="mt-8 flex flex-wrap gap-x-8 gap-y-4">
              <div>
                <p className="font-display text-3xl md:text-4xl">7<span className="text-[#FF3B00]">+</span></p>
                <p className="mt-1 font-mono-acc text-[10px] text-[#525252]">Jahre Erfahrung</p>
              </div>
              <div>
                <p className="font-display text-3xl md:text-4xl">6</p>
                <p className="mt-1 font-mono-acc text-[10px] text-[#525252]">Stationen</p>
              </div>
              <div>
                <p className="font-display text-3xl md:text-4xl">3</p>
                <p className="mt-1 font-mono-acc text-[10px] text-[#525252]">Sprachen</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
